import RouterProps from './RoutesProvider';

export default RouterProps;
